import React, { useState } from 'react';
import useManageUser from './useManageUser';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const { error, login } = useManageUser();
  const {loginUser} = useAuth()

  const initialValue = {
    identifier: '',
    password: ''
  }

  const [user, setUser] = useState(initialValue)
  const navigate = useNavigate()
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleForgotPassword = async () => {
    navigate('/forgotpassword')
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    const returnResult = await login(user);
    if(returnResult.error){
      toast.error(returnResult.error)
    }else{
      const {isAuthenticated, token, user: userData} = returnResult
      // Check if login was successful
      if (returnResult && isAuthenticated) {
          toast.success('Login Successfully');
          loginUser(userData, token)
          // Redirect based on userData role
          if (userData.role === 'admin' || userData.role === 'superuser') {
              navigate('/keydata');
          } else {
              navigate('/sendonly');
          }
      } else {
        toast.error(error);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="max-w-md w-full"> {/* This div will act as the card */}
          <div className="bg-white shadow-lg rounded-lg px-8 py-10"> {/* Card styling */}
          <div>
          <img
            className="mx-auto h-60 w-auto"
            src="https://res.cloudinary.com/dkeybfbhj/image/upload/v1703700428/resources/ej6cuul9mgff3mnmxyfh.png"
            alt="Your Logo"
          />
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Sign in to your account
            </h2>
          </div>
          <form className="mt-8" onSubmit={handleLogin} method="post">
            <div className='flex'>
              <input
                id="identifier"
                name="identifier"
                type="string"
                required
                value={user?.identifier}
                onChange={handleInputChange}
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Username"
              />
            </div>
            <div className='mt-3'>
              <input
                id="password"
                name="password"
                type="password"
                value={user?.password}
                onChange={handleInputChange}
                autoComplete="current-password"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Password"
              />
            </div>
            <div className='flex mt-2'>
              <button
                type='button'
                className='ml-auto text-blue-500 cursor-pointer hover:text-blue-700'
                onClick={handleForgotPassword}
              >
                Forgot password?
              </button>
            </div>
            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
